const mixins = {
    methods: {
        updateSliderFromInput(index){
            let minValue = parseInt(this.filters[index].minValue)
            let min = parseInt(this.filters[index].min)
            let maxValue = parseInt(this.filters[index].maxValue)
            let max = parseInt(this.filters[index].max)

            if(minValue <= maxValue && minValue >= min && maxValue >= minValue && maxValue <= max)
                this.filters[index].slider = [minValue, maxValue]
            this.updateInputsFromSlider(index)
        },
        updateInputsFromSlider(index){
            this.filters[index].minValue = this.filters[index].slider[0]
            this.filters[index].maxValue = this.filters[index].slider[1]
        },
    }
};

export default mixins;